<template>
	<v-container fluid class="blue-grey lighten-5">
		<v-container grid-list-lg>
			<v-row class="mt-5 font-weight-black black--text text-xs-center">
				<h1 class="mt-3 black--text font-weight-bold">فرم درخواست</h1>
			</v-row>
			<!-- <v-divider class="mt-5"></v-divider> -->
			<v-row class="mt-10">
				<v-col wrap>
					<!-- <v-divider></v-divider> -->
					<!-- <h3 class="subheading mt-2 grey--text font-weight-thin">
				کاربر گرامی شرکت رقم سازان در راستای احترام به حقوق مصرف کنندگان
				و دریافت های پشتیبانی امکاناتی فراهم نموده تا شما به راحتی
				درخواست های پشتیبانی را برای ما ارسال فرمائید تا در اسرع وقت
				پیگیری نماییم.
			</h3> -->
					<v-form
						ref="form"
						v-model="valid"
						lazy-validation
						@submit.prevent="sendTicket"
					>
						<v-text-field
							v-model="name"
							:counter="15"
							:rules="nameRules"
							label="نام و نام خانوادگی"
							required
						></v-text-field>
						<v-text-field
							v-model="email"
							:rules="emailRules"
							label="E-mail"
							required
						></v-text-field>
						<v-text-field
							v-model="mobile"
							:rules="mobileRules"
							:counter="11"
							label="موبایل"
							required
						></v-text-field>
						<v-text-field
							v-model="packSerial"
							:rules="packRules"
							:counter="16"
							label="شماره پک"
							required
						></v-text-field>
						<v-select
							v-model="productType"
							:items="productTypeItems"
							filled
							light
							label="نوع محصول"
						></v-select>
						<v-select
							v-model="requestType"
							:items="requestTypeItems"
							filled
							light
							label="نوع درخواست"
						></v-select>
						<!-- <v-text-field
							v-model="module"
							:rules="moduleRules"
							:counter="15"
							label="  بخش مورد نظر (ماژول)"
						></v-text-field> -->
						<v-text-field
							v-model="subject"
							:rules="subjectRules"
							:counter="15"
							label="عنوان پیام"
						></v-text-field>

						<v-textarea
							v-model="text"
							label="متن پیام"
							:counter="1000"
							rows="5"
							:rules="textRules"
							row-height="25"
							required
						></v-textarea>
						<v-btn class="mr-5 success" type="submit">ارسال</v-btn>
					</v-form>
				</v-col>
			</v-row>
		</v-container>
	</v-container>
</template>
<script>
	export default {
		mounted: async function () {
			if (localStorage.lastMessage) {
				const message = JSON.parse(localStorage.lastMessage);
				this.name = message.name;
				this.email = message.email;
				this.mobile = message.mobile;
				this.packSerial = message.packSerial;
				this.productType = message.productType;
				this.subject = message.subject;
				this.text = message.text;
			}
		},
		data() {
			return {
				valid: false,
				name: "",
				nameRules: [
					(v) => !!v || "وارد کردن نام الزامی است",
					(v) => v.length <= 15 || "حداکثر 15 حرف باشد",
				],
				email: "",
				emailRules: [
					(v) => !!v || "وارد کردن ایمیل الزامی است",
					(v) => /.+@.+/.test(v) || "ایمیل وارد شده صحیح نمی باشد",
				],
				mobile: "",
				mobileRules: [
					(v) => !!v || "وارد کردن این فیلد الزامی است",
					(v) => v.length <= 16 || "حداکثر 11 حرف باشد",
					(v) => /^\d*$/.test(v) || "شماره وارد شده صحیح نمی باشد",
				],
				packSerial: "",
				packRules: [
					// (v) => !!v || "وارد کردن این فیلد الزامی است",
					(v) => v.length <= 16 || "حداکثر 16 حرف باشد",
					(v) => /^\d*$/.test(v) || "شماره وارد شده صحیح نمی باشد",
				],
				module: "",
				moduleRules: [(v) => v.length <= 15 || "حداکثر 15 حرف باشد"],
				subject: "",
				subjectRules: [
					(v) => v.length <= 15 || "حداکثر 15 حرف باشد",
					(v) => !!v || "وارد کردن این فیلد الزامی است",
				],
				text: "",
				textRules: [
					(v) => v.length <= 1000 || "حداکثر 1000 حرف باشد",
					(v) => !!v || "وارد کردن این فیلد الزامی است",
				],
				productType: "نرم افزار پازار نسخه پلاس",
				productTypeItems: [
					"نرم افزار پازار نسخه پلاس",
					"نرم افزار پازار نسخه 12",
					"پرتال پازارپلاس",
					"موتور جستجوی کالاها و خدمات آسان۳۶۰",
					" سایر محصولات",
				],
				requestType: "پیشنهاد تغییرات و یا امکانات جدید",
				requestTypeItems: [
					"پیشنهاد تغییرات و یا امکانات جدید",
					"درخواست مشاوره",
					"گزارش خطا",
				],
			};
		},
		methods: {
			// toggle() {
			// 	var plus = document.getElementById("plus");
			// 	if (plus.style.display == "block") {
			// 		plus.style.display = "none";
			// 	} else {
			// 		plus.style.display = "block";
			// 	}
			// },
			sendTicket() {
				const message = {
					name: this.name,
					email: this.email,
					mobile: this.mobile,
					productType: this.productType,
					packSerial: this.packSerial,
					module: this.module,
					subject: this.subject,
					text: this.text,
				};
				localStorage.lastMessage = JSON.stringify(message);

				if (!this.name || !this.mobile || !this.subject || !this.text) {
					alert("لطفا فیلدهای ضروری را وارد نمایید.");
				} else {
					message.subject = "";
					message.text = "";
					localStorage.lastMessage = JSON.stringify(message);
					alert("تیکت شما ثبت گردید.");
					this.$router.push(this.$route.query.redirect || "/");
				}
				// console.log(message);
			},
		},
	};
</script>
